// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"333cd26a","455":"b7899e5c","977":"b3f807af"}[chunkId] + ".chunk.js";
};